// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piechart_featured__6TJRx {
  display: flex;
  flex-direction: row;
 flex: 1 1; 
 align-items: center;
 align-content: center; 
  justify-content: space-between;
}

.piechart_featuredItem__rjsnc {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.piechart_featuredTitle__YvXKY{
     display: flex;
    align-items: center;
    justify-content: center; 
    font-size: 20px;
}

.piechart_featuredTitleYear__p0eVW{
    font-size: 12px;
    margin-left: 45%;
 }

.piechart_featuredTitleHeader__3v4YJ{
    font-size: 14px;
}


.piechart_featuredTextContainer__aBAQY{
    margin: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: center; 
    
}

.piechart_featuredText__L0jWu{
    font-size: 50px;
    font-weight: 600;
     display: flex;
    align-items: center;
    justify-content: center; 
    color: var(--hsrcOrange); 
}


.piechart_featuredIcon__0x4nJ{
    font-size: 14px;
    margin-left: 5px;
    color: green;
}

.piechart_featuredIcon__0x4nJ.piechart_negative__aplMR{
    color: red;
}

.piechart_featuredSub__M45kq{
    font-size: 15px;
    color: gray;
     display: flex;
    align-items: center;
    justify-content: center; 
}

.piechart_recharts-cartesian-axis-tick__rzAZb {    
 font-size:  10px !important;
    font-weight: 200;
}


.piechart_recharts-cartesian-axis__rt1wQ {
    font-size: 10px !important;
    font-weight: 100;
}


.piechart_label_text__JIulZ {
    font-size:  10px !important;
    font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/PieChartWidget/piechart.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;CACpB,SAAO;CACP,mBAAmB;CACnB,qBAAqB;EACpB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EAEf,kDAAkD;AACpD;;AAEA;KACK,aAAa;IACd,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;CACnB;;AAED;IACI,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,gBAAgB;KACf,aAAa;IACd,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;KACV,aAAa;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,2BAA2B;IACxB,gBAAgB;AACpB;;;AAGA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;;AAGA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB","sourcesContent":[".featured {\r\n  display: flex;\r\n  flex-direction: row;\r\n flex: 1; \r\n align-items: center;\r\n align-content: center; \r\n  justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n  box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitle{\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    font-size: 20px;\r\n}\r\n\r\n.featuredTitleYear{\r\n    font-size: 12px;\r\n    margin-left: 45%;\r\n }\r\n\r\n.featuredTitleHeader{\r\n    font-size: 14px;\r\n}\r\n\r\n\r\n.featuredTextContainer{\r\n    margin: 10px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    \r\n}\r\n\r\n.featuredText{\r\n    font-size: 50px;\r\n    font-weight: 600;\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    color: var(--hsrcOrange); \r\n}\r\n\r\n\r\n.featuredIcon{\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n    color: green;\r\n}\r\n\r\n.featuredIcon.negative{\r\n    color: red;\r\n}\r\n\r\n.featuredSub{\r\n    font-size: 15px;\r\n    color: gray;\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n}\r\n\r\n.recharts-cartesian-axis-tick {    \r\n font-size:  10px !important;\r\n    font-weight: 200;\r\n}\r\n\r\n\r\n.recharts-cartesian-axis {\r\n    font-size: 10px !important;\r\n    font-weight: 100;\r\n}\r\n\r\n\r\n.label_text {\r\n    font-size:  10px !important;\r\n    font-weight: 400;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `piechart_featured__6TJRx`,
	"featuredItem": `piechart_featuredItem__rjsnc`,
	"featuredTitle": `piechart_featuredTitle__YvXKY`,
	"featuredTitleYear": `piechart_featuredTitleYear__p0eVW`,
	"featuredTitleHeader": `piechart_featuredTitleHeader__3v4YJ`,
	"featuredTextContainer": `piechart_featuredTextContainer__aBAQY`,
	"featuredText": `piechart_featuredText__L0jWu`,
	"featuredIcon": `piechart_featuredIcon__0x4nJ`,
	"negative": `piechart_negative__aplMR`,
	"featuredSub": `piechart_featuredSub__M45kq`,
	"recharts-cartesian-axis-tick": `piechart_recharts-cartesian-axis-tick__rzAZb`,
	"recharts-cartesian-axis": `piechart_recharts-cartesian-axis__rt1wQ`,
	"label_text": `piechart_label_text__JIulZ`
};
export default ___CSS_LOADER_EXPORT___;
